import type { SubjectFact } from '../../types/api';
import { ComputedFactsSection } from './facts/ComputedFactsSection';

export function SubjectFactsSection({ facts }: { facts: SubjectFact[] }) {
    return <ComputedFactsSection entityKind="subject" facts={facts} />;
}
